import http from '../http-common';

class AttendanceService {
  getScopes(params) {
    return http.get('/attendances/scopes', { params });
  }

  getSheet(params) {
    return http.get('/attendances/sheet', { params });
  }

  bulkSave(data) {
    return http.post('/attendances/bulk', data);
  }
}

export default new AttendanceService();
